
    /**
     * Gets the "kind" of value. (e.g. "String", "Number", etc)
     */
    function kindOf(val) {
        return Object.prototype.toString.call(val).slice(8, -1);
    }
    module.exports = kindOf;




//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/lang/kindOf.js
// module id = 370
// module chunks = 6